import { FormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PageTopComponent } from "./page-top/page-top.component";

//hu
import { AddrInputModule } from './addr-input/addr-input.module'; //home  job
import { JobCategoryModule } from './job-category/job-category.module'; //home
import { PageBottomModule } from './page-bottom/page-bottom.module';
import { JobShortModule } from './job-short/job-short.module';//home
import { JobDetailSmallModule } from './job-detail-small/job-detail-small.module'; //job course
import { PageIndexComponent } from './page-index/page-index.component'; //分页
import { JobCompanyModule } from './job-company/job-company.module';    //job   coures
import { AddrModalModule } from './addr-modal/addr-modal.module';  //home  job
import { SmallTitleModule } from './small-title/small-title.module';  // home job curese user information
import { JobClassModule } from './job-class/job-class.module';//岗位分类
//chen
import { CourseHotModule } from "./course-hot/course-hot.module";
import { TopCourseModule } from "./top-course/top-course.module";
import { CourseFitComponent } from "./course-fit/course-fit.component";
import { SharedService } from './shared.service';
import { UserAuthModule } from "./user-auth/user-auth.module";
import { PictrueUploaderModule } from "./pictrue-uploader/pictrue-uploader.module";
import { NgUploaderModule } from "ngx-uploader";
import { BaiduSharedComponent } from './baidu-shared/baidu-shared.component';

import { OverlayPanelModule, DropdownModule, DialogModule } from 'primeng/primeng';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadcrumbService } from './breadcrumb.service';
import {CusInnerHTMLDirective} from './directs/cus-inner-html.directive';
import { SchoolPickerItemComponent } from './school-picker-item/school-picker-item.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    NgUploaderModule,
    OverlayPanelModule,
    AddrModalModule,
    AddrInputModule,
    CourseHotModule,
    JobCategoryModule,
    JobShortModule,
    JobDetailSmallModule,
    TopCourseModule,
    JobCompanyModule,
    PictrueUploaderModule,
    PageBottomModule,
    SmallTitleModule,
    JobClassModule,
    DropdownModule,
    DialogModule,
  ],
  declarations: [
    PageTopComponent, PageIndexComponent, CourseFitComponent,
    BaiduSharedComponent, BreadcrumbComponent,
    CusInnerHTMLDirective, SchoolPickerItemComponent,
  ],
  exports: [
    PictrueUploaderModule,
    CusInnerHTMLDirective,
    SchoolPickerItemComponent,
    //chen
    PageTopComponent, PageIndexComponent,
    CourseFitComponent, CourseHotModule, TopCourseModule,
    //hu
    JobCategoryModule, AddrInputModule, PageBottomModule, JobShortModule, JobClassModule,
    JobDetailSmallModule, JobCompanyModule, AddrModalModule, SmallTitleModule, UserAuthModule,
    BaiduSharedComponent
  ],
  providers: [SharedService, BreadcrumbService],
})
export class SharedModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/shared.module.ts